var map = {
	"./alfa_leasing.svg": 11962,
	"./aliexpress.svg": 19215,
	"./ar.svg": 52376,
	"./aviasales.svg": 30204,
	"./avito.svg": 89978,
	"./best_doctor.svg": 49790,
	"./cdek.svg": 405,
	"./cian.svg": 22457,
	"./det_mir.svg": 5426,
	"./dodo.svg": 99566,
	"./ekoniva.svg": 91484,
	"./haier.svg": 84825,
	"./innopolis.svg": 1954,
	"./innova.svg": 5216,
	"./interfax.svg": 44815,
	"./komus.svg": 15891,
	"./krok.svg": 59809,
	"./lamoda.svg": 45329,
	"./lanit.svg": 59177,
	"./leroy_merlin.svg": 50085,
	"./megafon.svg": 82501,
	"./modulbank.svg": 27039,
	"./ostrovok.svg": 53487,
	"./pik.svg": 84665,
	"./rbk_money.svg": 38090,
	"./ru_center.svg": 177,
	"./samokat.svg": 29112,
	"./segmento.svg": 45939,
	"./selectel.svg": 43484,
	"./simple.svg": 79500,
	"./skyeng.svg": 62239,
	"./splat.svg": 3612,
	"./sports_ru.svg": 1732,
	"./uchi_ru.svg": 89734,
	"./vk.svg": 45108,
	"./yandex_praktikum.svg": 61462
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32391;